module.exports = __webpack_public_path__ + "img/ventajas principal.a295e378.jpg";